import { useState } from 'react';
import { removeBooking, setBookingStatus } from '../../services/bookings';
import useBookings from './useBookings';
import EnquiryModal from './EnquiryModal';
import { contactLinks } from './enquiryUtils';
import './enquiries.css';
import './admin-layout.css';

const fmt = (date) => new Date(date).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
const FILTERS = ['all', 'pending', 'confirmed', 'cancelled'];

export default function BookingsPanel() {
  const { bookings, error, loading, reload } = useBookings();
  const [filter, setFilter] = useState('all');
  const [query, setQuery] = useState('');
  const [notice, setNotice] = useState('');
  const [selectedId, setSelectedId] = useState(null);

  async function run(action) {
    try {
      await action();
      await reload();
      setNotice('');
    } catch (err) {
      setNotice(err.message);
    }
  }

  const term = query.trim().toLowerCase();
  const visible = bookings.filter((b) => (filter === 'all' || b.status === filter)
    && (!term || `${b.name} ${b.email} ${b.phone} ${b.room_name}`.toLowerCase().includes(term)));
  const selected = bookings.find((b) => b.id === selectedId);

  return (
    <div className="glass-stack">
      <div className="glass-card">
        <span className="eyebrow">Guest correspondence</span>
        <h2 className="glass-title">Booking enquiries</h2>
        <p className="muted">Requests from the website appear here. Contact guests directly to confirm their stay; add the assigned room to the Room schedule separately to block its dates.</p>
      </div>
      <div className="glass-card bookings-toolbar">
        <div className="filter-pills">
          {FILTERS.map((item) => (
            <button type="button" key={item} aria-pressed={filter === item} onClick={() => setFilter(item)}>{item}</button>
          ))}
        </div>
        <input className="glass-search" placeholder="Search guest, email, phone…" value={query} onChange={(e) => setQuery(e.target.value)} />
      </div>
      {(error || notice) && <p className="admin-warning" role="alert">{error || notice}</p>}
      {loading && <div className="glass-card">Loading enquiries…</div>}
      {!loading && visible.length === 0 && <div className="glass-card muted">No enquiries found.</div>}
      <div className="enq-grid">
      {visible.map((b) => (
        <article className="glass-card booking-item" key={b.id}>
          <header>
            <div><h3>{b.name}</h3><small>{b.email} · {b.phone}</small></div>
            <span className={`badge badge-${b.status}`}>{b.status}</span>
          </header>
          <p className="booking-meta">
            {fmt(b.check_in)} → {fmt(b.check_out)} · {b.guests} guest(s){b.room_name ? ` · ${b.room_name}` : ''}
          </p>
          {b.request && <p className="booking-note">“{contactLinks(b).note}”</p>}
          <footer>
            <small>Received {fmt(b.created_at)}</small>
            <div className="booking-actions">
              {contactLinks(b).whatsapp && <a className="enq-wa" href={contactLinks(b).whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp</a>}
              {b.email && <a href={`mailto:${b.email}`}>Email guest</a>}
              {b.phone && <a href={`tel:${b.phone.replace(/[^\d+]/g, '')}`}>Call guest</a>}
              {b.status !== 'confirmed' && <button type="button" onClick={() => run(() => setBookingStatus(b.id, 'confirmed'))}>Confirm</button>}
              {b.status !== 'cancelled' && <button type="button" onClick={() => run(() => setBookingStatus(b.id, 'cancelled'))}>Cancel</button>}
              {b.status !== 'pending' && <button type="button" onClick={() => run(() => setBookingStatus(b.id, 'pending'))}>Mark pending</button>}
              <button type="button" className="danger" onClick={() => window.confirm('Delete this booking?') && run(() => removeBooking(b.id))}>Delete</button>
              <button type="button" className="enq-view" onClick={() => setSelectedId(b.id)}>View</button>
            </div>
          </footer>
        </article>
      ))}
      </div>
      {selected && <EnquiryModal booking={selected} run={run} onClose={() => setSelectedId(null)} />}
    </div>
  );
}